import React from 'react'
import { IconButton, TableCell, TableRow, useMediaQuery, useTheme } from '@mui/material'
import EditIcon from '../assests/editicon.png';
import LockIcon from '../assests/lockicons.png';
import DeleteIcon from '../assests/deleticon.png';
// import CrossIcon from '../assests/croosicon.png';
import BlockIcon from "../../common/assests/blockIcon.png";
const UserPermissionRow = ({ row, blockResume,deleteAdmin,editedData}) => {
 
  
    const theme = useTheme();
    const isSmallScreen = useMediaQuery('(max-width:480px)');
    const getStatusLabel = (status) => {
      switch (status) {
        case 1:
          return 'Unverified';
        case 2:
          return 'Active';
        case 3:
          return 'Blocked';
        case 4:
          return 'Deleted';
        case 5:
          return 'Rejected';
        default:
          return '-';
      }
    };
  
    return (
      <TableRow key={row?._id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
        <TableCell sx={{ opacity: row?.account_status === 5 ? 0.6 : 1 }}>{row?.username}</TableCell>
        <TableCell sx={{ opacity: row?.account_status === 5 ? 0.6 : 1 }}>{row?.email}</TableCell>
        <TableCell sx={{ opacity: row?.account_status === 5 ? 0.6 : 1 }} >{row?.phone}</TableCell>
        <TableCell sx={{ opacity: row?.account_status === 5 ? 0.6 : 1 }}>{getStatusLabel(row?.account_status)}</TableCell>
        <TableCell sx={{ opacity: row?.account_status === 5 ? 0.6 : 1 }}>{new Date(row?.createdAt).toLocaleDateString()}</TableCell>
        <TableCell>
          <IconButton onClick={editedData}>
            <img src={EditIcon} alt="Edit" style={{ height: isSmallScreen ? '35px' : '45px', width: isSmallScreen ? '35px' : '45px' }} />
          </IconButton>
          <IconButton onClick={() => blockResume(row?._id, row?.lock)}>
            {row?.lock === true ? (
              <img
                src={BlockIcon}
                alt="unlockicon"
                style={{
                  height: isSmallScreen ? "35px" : "42px",
                  width: isSmallScreen ? "35px" : "45px",
                }}
              />
            ) : (
              <img
                src={LockIcon}
                alt="lockicon"
                style={{
                  height: isSmallScreen ? "35px" : "42px",
                  width: isSmallScreen ? "35px" : "45px",
                }}
              />
            )}
          </IconButton>
          <IconButton onClick={deleteAdmin}>
            <img src={DeleteIcon} alt="Delete" style={{ height: isSmallScreen ? '35px' : '45px', width: isSmallScreen ? '35px' : '45px' }} />
          </IconButton>
        </TableCell>
      </TableRow>
    );
  };
  

export default UserPermissionRow